import { render, staticRenderFns } from "./sentItems.vue?vue&type=template&id=33230f7e&scoped=true&"
import script from "./sentItems.vue?vue&type=script&lang=js&"
export * from "./sentItems.vue?vue&type=script&lang=js&"
import style0 from "./sentItems.vue?vue&type=style&index=0&id=33230f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33230f7e",
  null
  
)

export default component.exports